import { render, staticRenderFns } from "./notification.CU.vue?vue&type=template&id=1b481079&"
import script from "./notification.CU.vue?vue&type=script&lang=js&"
export * from "./notification.CU.vue?vue&type=script&lang=js&"
import style0 from "./notification.CU.vue?vue&type=style&index=0&id=1b481079&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports